import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LockClosedIcon, UserIcon } from "@heroicons/react/24/outline";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      console.log(email,password)
      const res = await fetch("http://localhost:8000/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();
      console.log(data)
      if (res.ok && data.token) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify(data.user || { name: "Admin" }));
        navigate("/admin/dashboard");
      } else {
        setError(data.message || "Invalid credentials");
      }
    } catch (err) {
      setError("Server error – check internet or API");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "2rem"
    }}>
      <div style={{
        background: "white",
        padding: "3rem 4rem",
        borderRadius: "20px",
        boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
        width: "100%",
        maxWidth: "420px"
      }}>
        <div style={{ textAlign: "center", marginBottom: "2rem" }}>
          <div style={{
            width: "80px",
            height: "80px",
            background: "#667eea",
            borderRadius: "50%",
            margin: "0 auto 1rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
            <LockClosedIcon style={{ width: "44px", color: "white" }} />
          </div>
          <h1 style={{ fontSize: "2rem", color: "#1e293b" }}>Welcome Back</h1>
          <p style={{ color: "#64748b" }}>Login to your admin panel</p>
        </div>

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: "1.5rem" }}>
            <div style={{ position: "relative" }}>
              <UserIcon style={{ position: "absolute", left: "12px", top: "14px", width: "20px", color: "#94a3b8" }} />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email address"
                style={{
                  width: "100%",
                  padding: "14px 14px 14px 44px",
                  border: "1px solid #cbd5e1",
                  borderRadius: "12px",
                  fontSize: "1rem"
                }}
              />
            </div>
          </div>

          <div style={{ marginBottom: "1rem" }}>
            <div style={{ position: "relative" }}>
              <LockClosedIcon style={{ position: "absolute", left: "12px", top: "14px", width: "20px", color: "#94a3b8" }} />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                style={{
                  width: "100%",
                  padding: "14px 14px 14px 44px",
                  border: "1px solid #cbd5e1",
                  borderRadius: "12px",
                  fontSize: "1rem"
                }}
              />
            </div>
          </div>

          {error && (
            <div style={{ color: "#ef4444", fontSize: "0.9rem", marginBottom: "1rem", textAlign: "center" }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "14px",
              background: "#667eea",
              color: "white",
              border: "none",
              borderRadius: "12px",
              fontSize: "1.1rem",
              fontWeight: "600",
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.7 : 1
            }}
          >
            {loading ? "Logging in..." : "Login to Dashboard"}
          </button>
        </form>

        <p style={{ textAlign: "center", marginTop: "2rem", color: "#94a3b8", fontSize: "0.9rem" }}>
          ©2025
        </p>
      </div>
    </div>
  );
}